import React, { useState } from 'react';

import { AxiosResponse } from 'axios';

import { SettingsPage, SettingsSectionConfig } from '@vyce/core/src/components/SettingsCard';
import { Team } from '@vyce/core/src/types';
import {
  ExpiringDocumentsSettingPayload,
  ExpiringDocumentsSettings,
  ExpiringDocumentsSettingsListResponse,
} from '@vyce/core/src/api/types';
import { getStaffRequest } from '@vyce/core/src/api/companies';

import { DocumentExpiryAlerts } from './components';

interface Props {
  companyId?: string;
  teams?: Team[];
  getSettings: (companyId: string) => Promise<AxiosResponse<ExpiringDocumentsSettingsListResponse>>;
  createSetting: (
    companyId: string,
    payload: ExpiringDocumentsSettingPayload
  ) => Promise<AxiosResponse<ExpiringDocumentsSettings>>;
  updateSetting: (
    companyId: string,
    settingId: string,
    payload: ExpiringDocumentsSettingPayload
  ) => Promise<AxiosResponse<ExpiringDocumentsSettings>>;
  deleteSetting: (companyId: string, settingId: string) => Promise<AxiosResponse<unknown>>;
  getStaff?: typeof getStaffRequest;
}

export const TeamsSettingsView: React.FC<Props> = ({
  companyId,
  teams = [],
  getSettings,
  createSetting,
  updateSetting,
  deleteSetting,
  getStaff,
}) => {
  const [openCards, setOpenCards] = useState<Record<string, boolean>>({});

  const isOpen = (key: string) => !!openCards[key];
  const setOpen = (key: string) => (expanded: boolean) =>
    setOpenCards(prev => ({ ...prev, [key]: expanded }));

  const sections: SettingsSectionConfig[] = [
    {
      label: 'Email alerts',
      rows: [
        {
          cards: [
            {
              key: 'documentExpiry',
              search: 'document expiry alerts right to work id qualifications email recipients teams',
              node: (
                <DocumentExpiryAlerts
                  companyId={companyId}
                  teams={teams}
                  expanded={isOpen('documentExpiry')}
                  onExpandedChange={setOpen('documentExpiry')}
                  getSettings={getSettings}
                  createSetting={createSetting}
                  updateSetting={updateSetting}
                  deleteSetting={deleteSetting}
                  getStaff={getStaff}
                />
              ),
            },
          ],
        },
      ],
    },
  ];

  return (
    <SettingsPage
      title="Settings"
      description="How Vyce Teams behaves for your company — who gets told what, and when."
      sections={sections}
    />
  );
};
